import React from 'react';
import PropTypes from 'prop-types';

const shopifyProductType = {
  imageUrl: PropTypes.string,
  linkUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
};

const ShopifyProduct = ({
  imageUrl, linkUrl, title, price,
}) => (
  <div className="shopify-product">
    <a href={linkUrl}>
      <span className="shopify-product__image">
        <img src={imageUrl} alt={title} />
      </span>
      <span className="shopify-product__title">{title}</span>
      <span className="shopify-product__price">{price}</span>
    </a>
  </div>
);

ShopifyProduct.propTypes = shopifyProductType;

ShopifyProduct.defaultProps = {
  imageUrl: undefined,
};

export { shopifyProductType };
export default ShopifyProduct;
